var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.ocrtemplate_add") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutters" },
            [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("administration.ocr_templates"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _vm._l(_vm.attachments, function (attachment, id) {
                        return _c(
                          "b-row",
                          {
                            key: id,
                            staticClass:
                              "justify-content-start mx-0 mb-3 px-0 align-items-center",
                          },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "d-flex ml-0",
                                attrs: { cols: "4" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between",
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: { id: "application-file-input" },
                                        model: {
                                          value: attachment.Name,
                                          callback: function ($$v) {
                                            _vm.$set(attachment, "Name", $$v)
                                          },
                                          expression: "attachment.Name",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(attachment.Name) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "d-flex ml-4" }, [
                                  _c("i", {
                                    staticClass: "fa-light fa-download",
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(id)
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "fa-light fa-magnifying-glass ml-3",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDoc(id)
                                      },
                                    },
                                  }),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "mb-0",
                                attrs: { variant: "primary", round: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.clearInvoice(id)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("common.del_label")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "justify-content-start" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group mb-0",
                              attrs: { cols: "6" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn",
                                  attrs: { round: "", size: "md" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openImportTemplate()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-light fa-upload mr-2",
                                    attrs: { size: "17px" },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("attachments.import_doc")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("input", {
                            key: _vm.refreshImport,
                            staticClass:
                              "item-input hiddenElementAllSize local-file-input",
                            attrs: { type: "file" },
                            on: {
                              change: function ($event) {
                                return _vm.saveDocument($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.emission_date"),
                          placeholderValue: _vm.$t(
                            "administration.emission_date"
                          ),
                        },
                        model: {
                          value: _vm.emissionDate,
                          callback: function ($$v) {
                            _vm.emissionDate = $$v
                          },
                          expression: "emissionDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.delivery_date"),
                          placeholderValue: _vm.$t(
                            "administration.delivery_date"
                          ),
                        },
                        model: {
                          value: _vm.deliveryDate,
                          callback: function ($$v) {
                            _vm.deliveryDate = $$v
                          },
                          expression: "deliveryDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.payment_date"),
                          placeholderValue: _vm.$t(
                            "administration.payment_date"
                          ),
                        },
                        model: {
                          value: _vm.paymentDate,
                          callback: function ($$v) {
                            _vm.paymentDate = $$v
                          },
                          expression: "paymentDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.reference"),
                          placeholderValue: _vm.$t("administration.reference"),
                        },
                        model: {
                          value: _vm.reference,
                          callback: function ($$v) {
                            _vm.reference = $$v
                          },
                          expression: "reference",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.number_client"),
                          placeholderValue: _vm.$t(
                            "administration.number_client"
                          ),
                        },
                        model: {
                          value: _vm.numberClient,
                          callback: function ($$v) {
                            _vm.numberClient = $$v
                          },
                          expression: "numberClient",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.creditor_name"),
                          placeholderValue: _vm.$t(
                            "administration.creditor_name"
                          ),
                        },
                        model: {
                          value: _vm.creditorName,
                          callback: function ($$v) {
                            _vm.creditorName = $$v
                          },
                          expression: "creditorName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t(
                            "administration.creditor_postal_code"
                          ),
                          placeholderValue: _vm.$t(
                            "administration.creditor_postal_code"
                          ),
                        },
                        model: {
                          value: _vm.creditorPostalCode,
                          callback: function ($$v) {
                            _vm.creditorPostalCode = $$v
                          },
                          expression: "creditorPostalCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t(
                            "administration.creditor_town_name"
                          ),
                          placeholderValue: _vm.$t(
                            "administration.creditor_town_name"
                          ),
                        },
                        model: {
                          value: _vm.creditorTownName,
                          callback: function ($$v) {
                            _vm.creditorTownName = $$v
                          },
                          expression: "creditorTownName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t(
                            "administration.creditor_street_name"
                          ),
                          placeholderValue: _vm.$t(
                            "administration.creditor_street_name"
                          ),
                        },
                        model: {
                          value: _vm.creditorStreetName,
                          callback: function ($$v) {
                            _vm.creditorStreetName = $$v
                          },
                          expression: "creditorStreetName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.creditor_email"),
                          placeholderValue: _vm.$t(
                            "administration.creditor_email"
                          ),
                        },
                        model: {
                          value: _vm.creditorEmail,
                          callback: function ($$v) {
                            _vm.creditorEmail = $$v
                          },
                          expression: "creditorEmail",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.creditor_phone"),
                          placeholderValue: _vm.$t(
                            "administration.creditor_phone"
                          ),
                        },
                        model: {
                          value: _vm.creditorPhone,
                          callback: function ($$v) {
                            _vm.creditorPhone = $$v
                          },
                          expression: "creditorPhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.creditor_iban"),
                          placeholderValue: _vm.$t(
                            "administration.creditor_iban"
                          ),
                        },
                        model: {
                          value: _vm.creditorIBAN,
                          callback: function ($$v) {
                            _vm.creditorIBAN = $$v
                          },
                          expression: "creditorIBAN",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.name"),
                          placeholderValue: _vm.$t("administration.name"),
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.postal_code"),
                          placeholderValue: _vm.$t(
                            "administration.postal_code"
                          ),
                        },
                        model: {
                          value: _vm.postalCode,
                          callback: function ($$v) {
                            _vm.postalCode = $$v
                          },
                          expression: "postalCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.town_name"),
                          placeholderValue: _vm.$t("administration.town_name"),
                        },
                        model: {
                          value: _vm.townName,
                          callback: function ($$v) {
                            _vm.townName = $$v
                          },
                          expression: "townName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.street_name"),
                          placeholderValue: _vm.$t(
                            "administration.street_name"
                          ),
                        },
                        model: {
                          value: _vm.streetName,
                          callback: function ($$v) {
                            _vm.streetName = $$v
                          },
                          expression: "streetName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.email"),
                          placeholderValue: _vm.$t("administration.email"),
                        },
                        model: {
                          value: _vm.Email,
                          callback: function ($$v) {
                            _vm.Email = $$v
                          },
                          expression: "Email",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.phone"),
                          placeholderValue: _vm.$t("administration.phone"),
                        },
                        model: {
                          value: _vm.phone,
                          callback: function ($$v) {
                            _vm.phone = $$v
                          },
                          expression: "phone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.iban"),
                          placeholderValue: _vm.$t("administration.iban"),
                        },
                        model: {
                          value: _vm.iban,
                          callback: function ($$v) {
                            _vm.iban = $$v
                          },
                          expression: "iban",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.amount"),
                          placeholderValue: _vm.$t("administration.amount"),
                        },
                        model: {
                          value: _vm.amount,
                          callback: function ($$v) {
                            _vm.amount = $$v
                          },
                          expression: "amount",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.amountHT"),
                          placeholderValue: _vm.$t("administration.amountHT"),
                        },
                        model: {
                          value: _vm.amountHT,
                          callback: function ($$v) {
                            _vm.amountHT = $$v
                          },
                          expression: "amountHT",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.amountTVA"),
                          placeholderValue: _vm.$t("administration.amountTVA"),
                        },
                        model: {
                          value: _vm.amountTVA,
                          callback: function ($$v) {
                            _vm.amountTVA = $$v
                          },
                          expression: "amountTVA",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.reason"),
                          placeholderValue: _vm.$t("administration.reason"),
                        },
                        model: {
                          value: _vm.reason,
                          callback: function ($$v) {
                            _vm.reason = $$v
                          },
                          expression: "reason",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { sm: "3" } }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }